'use client';

export type CookieConsent = 'accepted' | 'declined' | null;

const COOKIE_CONSENT_KEY = 'renoviax_cookie_consent';

export function getCookieConsent(): CookieConsent {
  if (typeof window === 'undefined') return null;
  
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  return consent as CookieConsent;
}

export function setCookieConsent(consent: CookieConsent): void {
  if (typeof window === 'undefined') return;
  
  if (consent) {
    localStorage.setItem(COOKIE_CONSENT_KEY, consent);
  } else {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
  }
}

export function hasUserMadeChoice(): boolean {
  return getCookieConsent() !== null;
}